import { render, staticRenderFns } from "./CompanyWasteCodes.vue?vue&type=template&id=2843a82c&"
import script from "./CompanyWasteCodes.vue?vue&type=script&lang=js&"
export * from "./CompanyWasteCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
